import { useEffect, useState } from "react";
import UserSectionMenu from "../../components/UserSectionMenu";
import Pagination from "../../components/Pagination";
import UserInformation from "../../components/UserInformation";
import AddApplicantForm from "./AddApplicantForm";
import AddUserBox from "../../components/AddUserBox";
import { MyContext } from "../../context/myContext";
import { PersianToEnglish } from "numeral-convert";
import HistoryPopUp from "../../components/HistoryPopUp";
import {
  getExcel,
  getNomadHistory,
  getNomadInsurance,
  selectNomadHistoryArray,
  selectShowForm,
  selectShowInsurance,
} from "../common-states/commonStatesSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getNomads,
  setNomadInfo,
  selectApplicantBodyArray,
  selectSelectedNomad,
  setInputs,
  setSelects,
} from "./applicantSlice";
import {
  showPopUp,
  callApiAgain,
  selectShowHistory,
  selectShowEditForm,
  selectCallApi,
} from "../common-states/commonStatesSlice";
import { handleShowPopUp } from "../common-states/handleShowPopUp";
import { toGregorian } from "jalaali-js";
import InsurancePopUp from "../../components/InsurancePopUp";

const ApplicantManagement = () => {
  const [state, setState] = useState({
    selectedValue: { term: "", city: "" },
    input: "",
    emptyInputAlert: false,
    emptySelectAlert: false,
    isSearched: false,
  });
  const allNomadsTableHead = [
    "حذف",
    "ویرایش",
    "سوابق",
    "بیمه نامه",
    "تعداد دام",
    "تعداد خانوار",
    "منطقه عشایری",
    "شهر",
    "شماره تماس",
    "کد ملی",
    "نام و نام خانوادگی",
    "ردیف",
  ];
  const nomadHistoryTableHead = [
    "هزینه",
    "حجم آب",
    "زمان تحویل",
    "تاریخ تحویل",
    "راننده",
    "زمان درخواست",
    "منطقه",
    "کد پیگیری",
    "نوع آب",
    "ردیف",
  ];
  const [nomad, setNomad] = useState({ id: null, name: "" });
  const storeDispatch = useDispatch();
  const dispatch = useDispatch();
  const bodyArray = useSelector(selectApplicantBodyArray);
  const callApi = useSelector(selectCallApi);
  const showForm = useSelector(selectShowForm);
  const showEditForm = useSelector(selectShowEditForm);
  const showHistory = useSelector(selectShowHistory);
  const showInsurance = useSelector(selectShowInsurance);

  const selectedNomad = useSelector(selectSelectedNomad);
  const historyArray = useSelector(selectNomadHistoryArray);
  const handleShowForm = (item) => {
    setNomad({ ...nomad, id: item.nomad_id }); // set id to send for put request in the form for editing nomad
    storeDispatch(showPopUp({ type: "showEditForm", value: !showEditForm }));
    if (showEditForm === false) {
      let birthday =
        item.birthday !== "0621-03-21"
          ? PersianToEnglish(
              new Date(item.birthday).toLocaleDateString("fa-IR"),
            )
          : "";
      let editInputs = {
        requestTankerDays: item?.request_tanker_days ?? "",
        fatherName: item.father_name ?? "",
        name: item.name,
        birthday: birthday,
        code: item.national_code,
        phone: item.mobiles[1]?.mobile ?? "",
        mobile: item.mobiles[0].mobile,
        distance: item.dewatering_to_evacuation_distance ?? "",
        family: item.population,
        insuredLiveStock: item.insured_livestock_count ?? "",
        liveStock: item.livestock_count,
        nomadicArea: item.region,
        waterVolume: item.water_volume,
        membershipNumber: item.authentication_id,
      };
      storeDispatch(setInputs(editInputs));
      let editSelects = {
        city: item?.city_id,
        province: item.province,
        tank:
          item.water_storage_type === 0
            ? "تانکر"
            : item.water_storage_type === 1
              ? "آب انبار"
              : "استخر",
        registrationType:
          item.authentication_type === 0
            ? "عضویت در تعاونی"
            : "مورد تایید رئیس",
      };
      storeDispatch(setSelects(editSelects));
    }
  };
  const handleShowHistory = (item) => {
    console.log(item);
    storeDispatch(showPopUp({ type: "showHistory", value: !showHistory }));
    setNomad({ ...nomad, id: item.nomad_id, name: item.name }); //set name to send for historyPopup as title
    if (showHistory === false) {
      storeDispatch(getNomadHistory({ nomad_id: item.nomad_id, page: 1 }));
    }
  };
  const handleShowInsurance = (item) => {
    console.log('insurance');
    storeDispatch(showPopUp({ type: "showInsurance", value: !showInsurance }));
    setNomad({ ...nomad, id: item.nomad_id, name: item.name }); //set name to send for historyPopup as title
    if (showInsurance === false) {
      storeDispatch(getNomadInsurance({ nomad_id: item.nomad_id, page: 1 }));
    }
  };
  const handleClosePopup = () => {
    handleShowPopUp(dispatch, showForm, showEditForm, showHistory,showInsurance);
    storeDispatch(setNomadInfo({ obj: null, type: "" }));
  };

  const handleGetExcel = (cityId) => {
    let items = [
      { item: "row", col_name: "ردیف" },
      { item: "name", col_name: "نام" },
      { item: "father_name", col_name: "نام پدر" },
      { item: "national_code", col_name: "کد ملی" },
      { item: "city_id", col_name: "شهر" },
      { item: "region", col_name: "منطقه عشایری" },
      { item: "water_storage_type", col_name: "نوع مخزن" },
      { item: "livestock_count", col_name: "تعدا دام" },
      { item: "population", col_name: "تعداد خانوار" },
    ];
    const data = {
      city_id: cityId === "" ? null : cityId,
      sheet_type: 1,
      items: items,
    };
    dispatch(getExcel(data));
  };

  const handleChangePage = (item) => {
    storeDispatch(getNomads({ searchParam: "", pageNum: item, dispatch }));
  };

  const handleSearch = (searchParam) => {
    dispatch(getNomads({ searchParam, pageNum: 1, dispatch }));
  };

  useEffect(() => {
    storeDispatch(getNomads({ searchParam: "", pageNum: 1, dispatch }));
    storeDispatch(callApiAgain(false));
    // eslint-disable-next-line
  }, [callApi]);

  useEffect(() => {
    if (selectedNomad?.obj !== null) {
      if (selectedNomad?.type === "showEditForm") {
        handleShowForm(selectedNomad?.obj);
      } else if (selectedNomad?.type === "showHistory") {
        handleShowHistory(selectedNomad?.obj);
      } else if (selectedNomad?.type === "showInsurance") {
        handleShowInsurance(selectedNomad?.obj);
      }
      storeDispatch(setNomadInfo({ obj: null, type: "" }));
    }
    // eslint-disable-next-line
  }, [selectedNomad]);
  const persianToEnglishNumber = (str) => {
    if (!str) return "";
    const persianNumbers = "۰۱۲۳۴۵۶۷۸۹";
    const englishNumbers = "0123456789";
    return str.replace(
      /[۰-۹]/g,
      (char) => englishNumbers[persianNumbers.indexOf(char)],
    );
  };
  const convertPersianToMiladi = (persianDateStr) => {
    const englishDigitDate = persianToEnglishNumber(persianDateStr);
    const parts = englishDigitDate.split(/[\/\-]/);
    if (parts.length !== 3) {
      throw new Error(
        "Invalid Persian date format. Use YYYY/MM/DD or YYYY-MM-DD",
      );
    }
    const jy = parseInt(parts[0], 10);
    const jm = parseInt(parts[1], 10);
    const jd = parseInt(parts[2], 10);
    const { gy, gm, gd } = toGregorian(jy, jm, jd);
    // Return as YYYY-MM-DD string (no time, no Z)
    return `${gy}/${String(gm).padStart(2, "0")}/${String(gd).padStart(2, "0")}`;
  };
  const [persianDate, setPersianDate] = useState({
    startDate: "سال-روز-ماه",
    endDate: "سال-روز-ماه",
  });
  return (
    <div className="applicant-box bg-white rounded-md p-2 sm:p-6">
      <div
        className={`${(showEditForm || showHistory || showForm || showInsurance) && "visible bg-slate-700 opacity-50"} dark-background`}
        onClick={handleClosePopup}
      ></div>
      <MyContext.Provider
        value={{
          handleShowHistory,
          headArray: nomadHistoryTableHead,
          bodyArray: historyArray,
          title: `سوابق درخواست های ${nomad?.name}`,
        }}
      >
        <HistoryPopUp
          excelData={{
            items: [
              { item: "row", col_name: "ردیف" },
              { item: "created_at", col_name: "تاریخ" },
              { item: "city_id", col_name: "شهر" },
              { item: "water_type", col_name: "نوع آب" },
              { item: "driver_id", col_name: "راننده" },
              { item: "nomad_id", col_name: "متقاضی" },
              { item: "is_rejected", col_name: "رد شده" },
              { item: "settlement_status", col_name: "وضعیت تسویه" },
              { item: "driver_delivered_at", col_name: "زمان تایید راننده" },
              { item: "description", col_name: "توضیحات" },
            ],
            sheet_type: 3,
            nomad_id: nomad?.id,
            start_created_at: convertPersianToMiladi(persianDate?.startDate),
            end_created_at: convertPersianToMiladi(persianDate?.endDate),
          }}
          persianDate={persianDate}
          setPersianDate={setPersianDate}
          nomad={nomad}
        />
      </MyContext.Provider>
      <MyContext.Provider
        value={{
          formTitle: "ویرایش متقاضی",
          showEditForm,
          handleShowForm,
          registerBtn: "ویرایش",
          nomadId: nomad?.id,
        }}
      >
        <AddUserBox formComponent={AddApplicantForm} />{" "}
        {/*This is for editNomadPopup*/}
      </MyContext.Provider>
        <MyContext.Provider
        value={{
          formTitle: "بیمه نامه های متقاضی",
          showInsurance,
          handleShowInsurance,
          registerBtn: "",
          nomadId: nomad?.id,
        }}
      >
        <InsurancePopUp           nomad={nomad}
 formComponent={AddApplicantForm} />{" "}
        {/*This is for editNomadPopup*/}
      </MyContext.Provider>
      <UserSectionMenu
        state={state}
        setState={setState}
        buttonText="افزودن متقاضی"
        formTitle="افزودن متقاضی جدید"
        formComponent={AddApplicantForm}
        getSearchedInfo={handleSearch}
        handleGetExcel={handleGetExcel}
      />
      <MyContext.Provider
        value={{
          headArray: allNomadsTableHead,
          bodyArray,
          title: "مشخصات مشترکین ثبت شده",
        }}
      >
        <UserInformation />
      </MyContext.Provider>
      <Pagination handleChangePage={handleChangePage} callApi={callApi} />
    </div>
  );
};

export default ApplicantManagement;
